import { makeStyles } from "@mui/styles";
import {alpha} from "@mui/material/styles";
import {Theme} from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    position: "relative",
    padding: "16px 16px",
    marginBottom: 8,
  },
  top: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  id: {
    color: alpha(theme.palette.text.secondary, 0.6),
    paddingRight: 40,
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: 8,
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 8,
  },
  label: {
    color: alpha(theme.palette.text.secondary, 0.6),
    marginRight: 4,
  },
  fieldLabel: {
    marginRight: 4,
    lineHeight: 1.7,
    opacity: 0.6,
  },
  fieldBody: {
    lineHeight: 1.4,
    overflow: 'hidden',
  },
  actions: {
    paddingTop: 16,
  },
  button: {
    width: "100%",
  },
}));
